import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { LayoutState } from './layout.types';

const initialState: LayoutState = {
  showGlobalImportantNotices: undefined,
  showGlobalAntiSinGovNotice: undefined,
};

const layoutSlice = createSlice({
  initialState,
  name: 'layout',
  reducers: {
    setShowGlobalImportantNotices(state, action: PayloadAction<boolean>) {
      state.showGlobalImportantNotices = action.payload;
    },
    setShowGlobalAntiSinGovNotice(state, action: PayloadAction<boolean>) {
      state.showGlobalAntiSinGovNotice = action.payload;
    },
  },
});

export const { actions: layoutAction } = layoutSlice;

export default layoutSlice.reducer;
